const api = () => {
  return {
    bmw: route_api_url,
    dqe: route_api_url + "/assets/utils/dqe.php",
	dqeWithDealers: route_api_url + "/api/dqe",
    appPrefix: ""
  };
};

export default api;
